(function(){
  if(window.SoraTasteRecommendations) return;

  const coffeeTypes = new Set(['スペシャルティコーヒー']);
  // 店主のテイスティング判断を優先する銘柄。未指定の豆は下の共通スコアで選ぶ。
  const curatedPairs = {
    'brazil-caramelado': { similar: 'gwatemara', contrast: 'india' }
  };

  function stripHtml(value){
    return String(value || '').replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function tagsOf(product){
    if(Array.isArray(product.tags)) return product.tags;
    return String(product.tags || '').split(',').map(tag => tag.trim()).filter(Boolean);
  }

  function roastFromText(value){
    const text = stripHtml(value);
    if(/(?:【|^|[\s(（])浅煎り(?:】|$|[\s)）])/.test(text)) return 'light';
    if(/(?:【|^|[\s(（])中煎り(?:】|$|[\s)）])/.test(text)) return 'medium';
    if(/(?:【|^|[\s(（])深煎り(?:】|$|[\s)）])/.test(text)) return 'dark';
    return null;
  }

  function roastOf(product){
    const titleRoast = roastFromText(product.title);
    if(titleRoast) return titleRoast;

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const initialVariant = variants.find(variant => variant.available !== false) || variants[0];
    if(initialVariant){
      const variantText = [
        initialVariant.title,
        ...(Array.isArray(initialVariant.options) ? initialVariant.options : []),
        initialVariant.option1,
        initialVariant.option2,
        initialVariant.option3
      ].filter(Boolean).join(' ');
      const variantRoast = roastFromText(variantText);
      if(variantRoast) return variantRoast;
    }

    const tags = tagsOf(product);
    if(tags.includes('中煎り') || tags.includes('diagnosis-roast:medium')) return 'medium';
    if(tags.includes('深煎り') || tags.includes('diagnosis-roast:dark')) return 'dark';
    if(tags.includes('浅煎り') || tags.includes('diagnosis-roast:light')) return 'light';
    return null;
  }

  function stars(text, label){
    const match = stripHtml(text).match(new RegExp(label + '[　 ]*([★☆]{1,5})'));
    return match ? (match[1].match(/★/g) || []).length : -1;
  }

  function profileOf(product){
    const text = [product.title, product.body_html, product.description].filter(Boolean).join(' ');
    return {
      roast: roastOf(product),
      bitter: stars(text, '苦味'),
      acid: stars(text, '酸味'),
      sweet: Math.max(stars(text, '甘み'), stars(text, '甘さ')),
      body: stars(text, 'コク'),
      aroma: stars(text, '香り')
    };
  }

  function isCoffee(product){
    const tags = tagsOf(product);
    const identity = `${product.handle || ''} ${stripHtml(product.title)}`;
    return coffeeTypes.has(product.product_type || product.type) &&
      !tags.some(tag => /ランキング除外|初回限定セット|高価格|デカフェ|カフェインレス/.test(tag)) &&
      !/セット|定期便|デカフェ|カフェインレス|decaf/i.test(identity);
  }

  function available(product){
    return (product.variants || []).some(variant => variant.available !== false);
  }

  function flavorTags(product){
    return tagsOf(product).filter(tag => /^diagnosis-flavor:/.test(tag));
  }

  function featureDistance(a, b){
    return ['bitter', 'acid', 'sweet', 'body', 'aroma'].reduce((total, key) => {
      if(a[key] < 0 || b[key] < 0) return total + 2;
      return total + Math.abs(a[key] - b[key]);
    }, 0);
  }

  function sharedFlavorCount(a, b){
    const aTags = new Set(flavorTags(a));
    return flavorTags(b).filter(tag => aTags.has(tag)).length;
  }

  function roastLabel(roast){
    return ({ light: '浅煎り', medium: '中煎り', dark: '深煎り' })[roast] || '別の焙煎度';
  }

  function similarReason(current, currentProfile, candidateProfile){
    if(current.sora_variant_roast_override){
      return `同じ${roastLabel(currentProfile.roast)}で、銘柄ごとの違いをゆっくり楽しめます`;
    }
    const shared = [];
    if(Math.abs(currentProfile.sweet - candidateProfile.sweet) <= 1) shared.push('甘み');
    if(Math.abs(currentProfile.body - candidateProfile.body) <= 1) shared.push('コク');
    if(Math.abs(currentProfile.acid - candidateProfile.acid) <= 1) shared.push('酸味');
    const axes = shared.slice(0, 2).join('・') || '味のバランス';
    return `同じ${roastLabel(currentProfile.roast)}で、${axes}の近い一杯です`;
  }

  function contrastReason(current, currentProfile, candidateProfile){
    const roast = roastLabel(candidateProfile.roast);
    if(current.sora_variant_roast_override){
      return `${roast}に変えて、いつもと少し違う味わいを楽しめます`;
    }
    if(candidateProfile.acid >= 0 && currentProfile.acid >= 0 && candidateProfile.acid < currentProfile.acid){
      const stronger = [];
      if(candidateProfile.bitter > currentProfile.bitter) stronger.push('苦味');
      if(candidateProfile.body > currentProfile.body) stronger.push('コク');
      if(stronger.length){
        return `酸味は穏やかに、${stronger.join('と')}をしっかり楽しめる${roast}です`;
      }
      return `酸味が穏やかな${roast}で、落ち着いた味わいです`;
    }
    if(candidateProfile.acid > currentProfile.acid){
      return `${roast}ならではの明るい酸味を、少し楽しみたいときに`;
    }
    return `${roast}に変えて、苦味とコクの違いを楽しめます`;
  }

  function pick(current, products){
    if(!current) return [];
    const currentProfile = profileOf(current);
    if(!currentProfile.roast) return [];
    const candidates = (products || []).filter(product =>
      String(product.id) !== String(current.id) && isCoffee(product) && available(product) && profileOf(product).roast
    );

    const curated = curatedPairs[current.handle] || {};
    const scoredSimilar = candidates
      .filter(product => profileOf(product).roast === currentProfile.roast)
      .sort((a, b) => {
        const ap = profileOf(a);
        const bp = profileOf(b);
        const aScore = featureDistance(currentProfile, ap) - sharedFlavorCount(current, a) * 2;
        const bScore = featureDistance(currentProfile, bp) - sharedFlavorCount(current, b) * 2;
        return aScore - bScore || Number(a.id) - Number(b.id);
      })[0];
    const sameRoast = candidates.find(product => product.handle === curated.similar && profileOf(product).roast === currentProfile.roast) || scoredSimilar;

    const targetRoast = currentProfile.roast === 'dark' ? 'medium' : currentProfile.roast === 'medium' ? 'dark' : 'medium';
    const scoredContrast = candidates
      .filter(product => product !== sameRoast && profileOf(product).roast === targetRoast)
      .sort((a, b) => {
        const ap = profileOf(a);
        const bp = profileOf(b);
        const targetAcid = currentProfile.roast === 'dark' ? currentProfile.acid + 1 : Math.max(0, currentProfile.acid - 1);
        const aScore = Math.abs(ap.acid - targetAcid) * 3 + featureDistance(currentProfile, ap) - sharedFlavorCount(current, a) * 2;
        const bScore = Math.abs(bp.acid - targetAcid) * 3 + featureDistance(currentProfile, bp) - sharedFlavorCount(current, b) * 2;
        return aScore - bScore || Number(a.id) - Number(b.id);
      })[0];
    const contrast = candidates.find(product => product.handle === curated.contrast && product !== sameRoast && profileOf(product).roast === targetRoast) || scoredContrast;

    const result = [];
    if(sameRoast){
      result.push({ kind: 'similar', label: '今の味わいに近い一杯', product: sameRoast, reason: similarReason(current, currentProfile, profileOf(sameRoast)) });
    }
    if(contrast){
      result.push({ kind: 'contrast', label: '少し気分を変える一杯', product: contrast, reason: contrastReason(current, currentProfile, profileOf(contrast)) });
    }
    return result;
  }

  function imageUrl(product){
    const image = product.featured_image || (product.images || [])[0];
    return typeof image === 'string' ? image : image && (image.src || image.url) || '';
  }

  window.SoraTasteRecommendations = { pick, profileOf, stripHtml, imageUrl };
})();
